import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";


import { useCallback, useEffect, useMemo } from "react";
import AppConfig from "../config/envConfig";

interface CognitoHelperProps {
  userPool: CognitoUserPool;
  getAuthenticatedUser: () => CognitoUser | null;
  signOut: () => void | undefined;
}

export default function useCognitoHelper(): CognitoHelperProps {
  const userPool = useMemo(() => new CognitoUserPool(AppConfig.poolData), []);

  const getAuthenticatedUser = useCallback(() => {
    return userPool.getCurrentUser();
  }, [userPool]);

  useEffect(() => {
    getAuthenticatedUser();
  }, [getAuthenticatedUser]);

  const signOut = () => {
    return userPool.getCurrentUser()?.signOut();
  };

  return {
    userPool,
    getAuthenticatedUser,
    signOut,
  };
}
